import React from 'react';

import Button from 'flow/components/ui-components/Button';
import Divider from 'flow/components/ui-components/Divider';
import IconBadge from 'flow/components/ui-components/IconBadge';
import Loading from 'flow/components/ui-components/Loading';

import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    dashboardUrl: string;
    onGenerateNewUrlClick: () => void;
    displayLoadingNewUrl: boolean;
    displayGenerationSuccessful: boolean;
}

const DashboardSettingsVisibility = ({
    dashboardUrl,
    onGenerateNewUrlClick,
    displayLoadingNewUrl,
    displayGenerationSuccessful,
}: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const confirmRegenerateDashboardUrl = () => {
        onGenerateNewUrlClick();
    };

    const getSecondaryItem = () => {
        if (displayLoadingNewUrl) {
            return (
                <Loading
                    size={18}
                    className="flex-row justify-end p-2"
                    disableTimeout={true}
                />
            );
        }

        if (displayGenerationSuccessful) {
            return (
                <div className="text-main flex items-center justify-end p-2">
                    <IconBadge
                        iconKey="check"
                        size={'18px'}
                        className="bg-green rounded-3xl text-white"
                    />
                </div>
            );
        }

        return (
            <Button
                className="p-2"
                onClick={() => {
                    openModal('confirmationDialog', {
                        title: i18next.t('wallboard.generateurl.title'),
                        description: i18next.t('dashboard.generate_url_info'),
                        handleAccept: confirmRegenerateDashboardUrl,
                    });
                }}
            >
                {i18next.t('wallboard.generateurl.title')}
            </Button>
        );
    };

    return (
        <div className="flex flex-col">
            <Divider />

            <div key="regenerateurl" className="h-[40px]">
                <div className="flex items-center justify-between ps-3">
                    <div className="text-link text-xs">{dashboardUrl}</div>
                    {getSecondaryItem()}
                </div>
            </div>

            <Divider />

            <div className="ms-3 mt-2.5 text-xs text-gray-500">
                {i18next.t('wallboard.regenerateurl.hint')}
            </div>
        </div>
    );
};

export default React.memo(DashboardSettingsVisibility);
